import { render } from "./menu.vue?vue&type=template&id=5b47e6fc&scoped=true"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"

import "./menu.vue?vue&type=style&index=0&id=5b47e6fc&scoped=true&lang=css"
import "./menu.vue?vue&type=style&index=1&id=5b47e6fc&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b47e6fc"]])

export default __exports__